import React from 'react';
import styled from 'styled-components';

function Input({ placeholder, setValue, type }) {
  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <InputContainer className='d-flex py-2'>
      <InputWindow
        type={type ? type : ''}
        className='form-control pl-2'
        placeholder={placeholder}
        onChange={handleChange}
      />
    </InputContainer>
  );
}

const InputContainer = styled.section``;
const InputWindow = styled.input`
  height: 51.5px;
  border: 1px solid #dddddd;
  border-radius: 5px;

  ::placeholder {
    color: #aaaaaa;
  }
`;

export default Input;
